import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent'
import { captureNativeConsole, forwardConsoleToNewRelic } from 'utils/consoleForwarder';


const remoteAudio = document.createElement('audio');
remoteAudio.id = 'remoteAudio';
remoteAudio.autoplay = true;
(remoteAudio as any).playsInline = true;
document.body.appendChild(remoteAudio);

// New Relic beacon traffic goes through the signalling service's proxy so ad blockers don't drop it.
// The agent expects host + path, without the protocol or a trailing slash.
const nrBeaconProxy = `${(process.env.REACT_APP_SIGNALLING_API_URL ?? '').replace(/^https?:\/\//, '').replace(/\/+$/, '')}/nr-beacon`;

const options = {
    init: { debug:{enabled: true, level: "debug"}, distributed_tracing: { enabled: true }, performance: { capture_measures: true }, privacy: { cookies_enabled: true }, ajax: { deny_list: ["bam.eu01.nr-data.net"] }, proxy: { beacon: nrBeaconProxy } },
    loader_config: {accountID:"3636923",trustKey:"3636923",agentID:"538764368",licenseKey:process.env.REACT_APP_NEW_RELIC_LICENCE ?? '', applicationID:"538764368"},
    info: {beacon:"bam.eu01.nr-data.net",errorBeacon:"bam.eu01.nr-data.net",licenseKey:process.env.REACT_APP_NEW_RELIC_LICENCE ?? '',applicationID:"538764368",sa:1}
}

// Grab the browser's console before the agent wraps it.
const nativeConsole = captureNativeConsole();

const NrAgent = new BrowserAgent(options);
(window as any).NrAgent = NrAgent;

forwardConsoleToNewRelic(NrAgent, nativeConsole);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);